import {
	ExpressionParser,
	ExpressionParseResultPayload,
	FrontEndExpressionParsePayload,
	ParseExpression,
	urlCombine,
} from 'ihub/common';
import {
	isURLSet,
	microServiceAPI,
	standardPost,
	validateOkResponse,
} from '../classes/http-helper-const';

export class ExpressionParserHttpService {
	async parseExpression(
		expressionPayload: FrontEndExpressionParsePayload
	): Promise<ExpressionParseResultPayload> {
		isURLSet();
		const url = urlCombine(microServiceAPI, ExpressionParser, ParseExpression);
		const response = await standardPost(url, expressionPayload);
		await validateOkResponse(response, 'Parse Expressions', ExpressionParser);
		return (await response.clone().json()) as ExpressionParseResultPayload;
	}
}
